const productTemplateForList = `
<c7-if product-image>
  <div className="c7-product__photo">
    <c7-product-image></c7-product-image>
  </div>
</c7-if>

<div className="c7-product__info">
  <h2 className="c7-product__title c7-title">
    <c7-product-title>
  </h2>

  <c7-if product-subtitle>
    <div class="c7-product-detail__subtitle c7-subtitle">
      <c7-product-subtitle>
    </div>
  </c7-if>

  <div className="c7-product__teaser">
    <p><c7-product-teaser></c7-product-teaser></p>
  </div>
  <c7-product-allocation />
  <c7-product-add-to-cart showVariantTitle="true"></c7-product-add-to-cart>
</div>

`;

export const listTemplate = `
<c7-products start="1" end="1">
  <div className="c7-product c7-product--featured">
    ${productTemplateForList}
  </div>
  </c7-products>
  <c7-products start="2">
  <div className="c7-product">
    ${productTemplateForList}
  </div>
</c7-products>
`;

export const collectionTemplate = `
<c7-products>
  <div className="c7-product">
    ${productTemplateForList}
  </div>
</c7-products>
`;

export const drilldownTemplate = `
<div className="c7-product-detail">
    <h1 className="c7-product-detail__titles"><c7-product-title></h1>
  <div className="c7-product-detail__photo">
    <c7-product-image>
  </div>
  <div className="c7-product-detail__info">
    <c7-product-allocation />
    <c7-product-add-to-cart>
    <c7-product-content>
    <c7-product-wine>
  </div>
</div>

`;
